import { useEffect } from "react";

/**
 * SEO helper: sets document.title, meta description, canonical URL and optional JSON-LD.
 * Lightweight alternative to react-helmet for an SPA crawlable by modern search engines.
 */
export default function SEO({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);

      // sync og:description + twitter:description
      ["og:description", "twitter:description"].forEach((key) => {
        const attr = key.startsWith("og:") ? "property" : "name";
        let t = document.querySelector(`meta[${attr}="${key}"]`);
        if (!t) {
          t = document.createElement("meta");
          t.setAttribute(attr, key);
          document.head.appendChild(t);
        }
        t.setAttribute("content", description);
      });
    }

    if (title) {
      ["og:title", "twitter:title"].forEach((key) => {
        const attr = key.startsWith("og:") ? "property" : "name";
        let t = document.querySelector(`meta[${attr}="${key}"]`);
        if (!t) {
          t = document.createElement("meta");
          t.setAttribute(attr, key);
          document.head.appendChild(t);
        }
        t.setAttribute("content", title);
      });
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    let jsonLdEl = null;
    if (jsonLd) {
      jsonLdEl = document.createElement("script");
      jsonLdEl.type = "application/ld+json";
      jsonLdEl.text = JSON.stringify(jsonLd);
      jsonLdEl.setAttribute("data-seo-runtime", "true");
      document.head.appendChild(jsonLdEl);
    }
    return () => {
      if (jsonLdEl && jsonLdEl.parentNode) jsonLdEl.parentNode.removeChild(jsonLdEl);
    };
  }, [title, description, canonical, jsonLd]);

  return null;
}
